<template>
  <section>
    <div class="login-form__inner-container">
      <EmailVerification :email="form.email" @verification:successful="handleVerificationEvent" v-if="verificationEmail" />
      <form autocomplete="off" v-else @submit.prevent="login">
        <div
          :class="{
            'logo-container': true,
            'justify-content-start':  getCompany.logo_placement === 'left',
            'justify-content-center': getCompany.logo_placement === 'center',
            'login-form__getCompany-logo mb-3': true,
            'd-none': !isLandingPage,

          }">
        </div>
        <div :class="{
            'text-light-blue-1 fs-24 font-weight-bold mt-2': true,
            'text-center': getCompany.logo_placement === 'center',
            'text-left': getCompany.logo_placement === 'left',
            'd-none': isLandingPage
            }">
          Log in to apply for this job opening
        </div>
        <div :class="{
            'text-center': logoPlacement === 'center' || !logoPlacement && getCompany.logo_placement === 'center',
            'text-left': logoPlacement === 'left' || !logoPlacement && getCompany.logo_placement === 'left',
            'd-none': !isLandingPage
            }">
          <h1 class="fs-20 text-dark-grey-1 login-form__primary-heading fw-500 text-center">Welcome Back</h1>
          <p class="fs-15 text-dark-grey-1 login-form__secondary-heading--xs mt-2">Continue your application and access your candidate profile.</p>
          <p class="fs-15 text-dark-grey-1 login-form__secondary-heading--md mt-2 text-center">Continue your application and access your candidate profile.</p>
        </div>
        <div :class="[
            isLandingPage ? 'd-none' : '',
            getCompany.logo_placement === 'center' ? 'text-center' : 'text-left',
            'text-muted fs-16 mt-2']">
            Monitor and manage your applications on the job board
        </div>
        <div class="d-flex flex-column mt-2 text-center flex-sm-row justify-content-sm-between flex-md-column text-md-center flex-lg-row justify-content-lg-between mx-n2 mt-n1">
          <div v-if="linkedinLogin == true" class="d-flex flex-fill p-2">
              <SfeButton type="button" class="btn btn-primary-linkedin fw-500 fs-14 py-2 flex-fill text-white" @click.prevent="authProvider('linkedin')">
                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M17.0392 17.0433H14.0775V12.4025C14.0775 11.2958 14.055 9.87167 12.5342 9.87167C10.99 9.87167 10.7542 11.0758 10.7542 12.3208V17.0433H7.7925V7.5H10.6375V8.80083H10.6758C11.0733 8.05083 12.04 7.25917 13.4842 7.25917C16.485 7.25917 17.04 9.23417 17.04 11.805L17.0392 17.0433ZM4.4475 6.19417C4.22156 6.19428 3.99783 6.14983 3.78909 6.06337C3.58035 5.97691 3.39071 5.85013 3.23103 5.69029C3.07135 5.53045 2.94475 5.34069 2.85849 5.13187C2.77224 4.92305 2.728 4.69927 2.72833 4.47333C2.7285 4.13315 2.82954 3.80065 3.01867 3.51789C3.2078 3.23513 3.47654 3.01481 3.79089 2.88478C4.10524 2.75474 4.45109 2.72085 4.78471 2.78738C5.11832 2.85391 5.42472 3.01787 5.66515 3.25853C5.90558 3.4992 6.06924 3.80575 6.13545 4.13943C6.20165 4.47311 6.16742 4.81893 6.03709 5.13315C5.90675 5.44738 5.68616 5.7159 5.40322 5.90476C5.12028 6.09362 4.78768 6.19433 4.4475 6.19417ZM5.9325 17.0433H2.9625V7.5H5.9325V17.0433ZM18.5208 0H1.47583C0.66 0 0 0.645 0 1.44083V18.5592C0 19.3558 0.66 20 1.47583 20H18.5183C19.3333 20 20 19.3558 20 18.5592V1.44083C20 0.645 19.3333 0 18.5183 0H18.5208Z" fill="white"/>
                </svg>
                &nbsp;&nbsp;Continue with LinkedIn
              </SfeButton>
          </div>
          <div v-if="googleLogin  == true" class="d-flex flex-fill p-2">
              <SfeButton
                type="button"
                class="btn btn-outline-primary fw-500 fs-14 py-2 flex-fill"
                @click.prevent="authProvider('google')">
                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M18.1726 8.36727H17.5013V8.33268H10.0013V11.666H14.7109C14.0238 13.6064 12.1776 14.9993 10.0013 14.9993C7.24005 14.9993 5.0013 12.7606 5.0013 9.99935C5.0013 7.2381 7.24005 4.99935 10.0013 4.99935C11.2759 4.99935 12.4355 5.48018 13.3184 6.2656L15.6755 3.90852C14.1871 2.52143 12.1963 1.66602 10.0013 1.66602C5.39922 1.66602 1.66797 5.39727 1.66797 9.99935C1.66797 14.6014 5.39922 18.3327 10.0013 18.3327C14.6034 18.3327 18.3346 14.6014 18.3346 9.99935C18.3346 9.4406 18.2771 8.89518 18.1726 8.36727Z" fill="#FFC107"/>
                <path d="M2.62891 6.1206L5.36682 8.12852C6.10766 6.29435 7.90182 4.99935 10.0014 4.99935C11.276 4.99935 12.4356 5.48018 13.3185 6.2656L15.6756 3.90852C14.1872 2.52143 12.1964 1.66602 10.0014 1.66602C6.80057 1.66602 4.02474 3.4731 2.62891 6.1206Z" fill="#FF3D00"/>
                <path d="M10.0008 18.3336C12.1533 18.3336 14.1091 17.5099 15.5879 16.1703L13.0087 13.9878C12.1439 14.6454 11.0872 15.0011 10.0008 15.0003C7.83328 15.0003 5.99286 13.6182 5.29953 11.6895L2.58203 13.7832C3.9612 16.482 6.76203 18.3336 10.0008 18.3336Z" fill="#4CAF50"/>
                <path d="M18.1712 8.36857H17.5V8.33398H10V11.6673H14.7096C14.3809 12.5908 13.7889 13.3978 13.0067 13.9886L13.0079 13.9877L15.5871 16.1702C15.4046 16.3361 18.3333 14.1673 18.3333 10.0007C18.3333 9.4419 18.2758 8.89648 18.1712 8.36857Z" fill="#1976D2"/>
                </svg>
                &nbsp;&nbsp;Continue with Google&nbsp;&nbsp;
              </SfeButton>
          </div>
        </div>
        <div v-if="googleLogin == true  || linkedinLogin == true" class="d-flex align-items-center mt-3 mb-4">
          <SfeDivider/>
          <div class="text-muted px-2">OR</div>
          <SfeDivider/>
        </div>

        <div v-if="proceedWithMagicLink && magicLinkRequestSuccess && form.email" class="mb-4 p-3 bg-grey-light-1 border-radius-8">
            <p class="mb-0">If <span class="fw-500">{{ form.email }}</span>  has an account, you will receive an email with an access link to the platform.</p>
        </div>

        <div class="form-group mb-2 mt-3">
          <div class="text-dark-grey-1 fs-14 fw-400">Email</div>
          <SfeInput 
            :hasError="errors.email"
            v-model="form.email" 
            type="email" 
            id="candidate_login_email" 
            placeholder="example@gmail.com"
          />
          <ShrInputError :error="errors.email" />
        </div>
        <div v-if="!proceedWithMagicLink">
          <div class="form-group mb-2 mt-1">
            <div class="text-dark-grey-1 fs-14 fw-400">Password</div>
            <PasswordInput autocomplete="off" @input="handlePasswordInput" />
            <ShrInputError :error="errors.password" />
          </div>
          <div class="text-right mt-3">
            <a  href="h/advanced#/candidate/forgot-password" id="candidate_forgot_passowrd" class="text-primary-blue fs-15 fw-400">Reset Password</a>
          </div>
        </div>
        <div class="form-group mt-4">
          <SfeButton v-if="proceedWithMagicLink" @click.prevent="requestMagicLink" :disabled="!form.email || isRequesting" type="submit" id="admin_login_btn" class="login-form__btn btn fs-18 fw-400 text-center btn-primary-light-blue border-radius-8 py-2 d-flex align-items-center justify-content-center w-100">
              <span>Email Me a Sign-In Link</span>
              <SfeLoader v-if="isRequesting" class="ml-1" size="sm" color="white" />
          </SfeButton>

          <SfeButton v-else type="submit" :disabled="submitting || buttonIsDisabled" class="btn fs-18 fw-400 text-center btn-primary-light-blue border-radius-8 w-100 py-2">
            <span id="candidte_login_btn" class="d-flex align-items justify-content-center">
              <span>Login</span>
              <SfeLoader size="sm" color="white" class="ml-1" v-if="submitting" />
            </span>
          </SfeButton>
        </div>
        <div class="d-flex align-items-center my-3">
          <SfeDivider />
          <span class="text-muted px-2 text-nowrap fs-13">OR</span>
          <SfeDivider />
        </div>
        <SfeButton type="button" variant="outline" class="w-100" @click.prevent="switchAuthMethod">
          {{ proceedWithMagicLink ? 'Sign in with password' : 'Sign in with a magic link' }}
        </SfeButton>
      </form>
      <div :class="[isLandingPage ? '' : 'd-none', 'w-75 ml-auto mr-auto mt-4']">
        <div class="text-center">
          <p class="text-light-grey-1">New to SeamlessHiring?<a @click="handleRegistrationLinkClick" id="signUp_btn" href="#" class="text-primary ml-1 fw-500">Create Candidate Profile</a></p>
        </div>
      </div>
      <ClientPrivacyPolicy></ClientPrivacyPolicy>
      <p class="text-light-grey-1 text-center mt-2" v-if="$helpers.getObjectProperty(getCompany, 'client.name', 'SeamlessHR') == 'KPMG'">
        <small>
          The KPMG trademarks are the sole property of KPMG International Cooperative
        </small>
      </p>

       <!-- View jobs section begins -->

       <div :class="[ isLandingPage ? '' : 'd-none', 'text-center mt-3 border border-primary px-2 py-2 login-form__skip-section--xs']">
          <p class="fw-500 text-muted">Skip sign up to explore latest job postings</p>

          <p class="text-muted fs-14">Find jobs you might be interested in before you sign up to apply</p>

          <a href="h/advanced#/jobs" class="text-primary fw-500 fs-15">View Jobs</a>
        </div>

        <!-- View jobs section ends -->


    </div>
  </section>
</template>

<script>
import CandidateModel from "../../models/CandidateModel"
import EmailVerification from "./EmailVerification"
import ClientPrivacyPolicy from "../../components/auth/ClientPrivacyPolicy"
import PasswordInput from "../../components/auth/PasswordInput"

export default {
  name: 'LogInForm',
  mixins: [ CandidateModel ],
  components: { EmailVerification, ClientPrivacyPolicy, PasswordInput },
  data(){
    return {
      form: {
        password: '',
        email: '',
      },
      verificationEmail: this.$store.state.verificationEmail,
      submitting: false,
      errors: {},
      googleLogin: false,
      linkedinLogin: false,
      isRequesting: false,
      magicLinkRequestSuccess: false,
      proceedWithMagicLink: true,
      getCompany: {}
    }
  },
  computed: {
    buttonIsDisabled() {
      return Object.values(this.form).some(parameter => !parameter)
    }
  },
  props: {
    isLandingPage: {
      type: Boolean,
      default: false,
    },
    logoPlacement: {
        type: String,
        default: ''
    },
    company: {
      type: Object,
      default: () => ({})
    }
  },
  mounted() {
    const verificationEmail = sessionStorage.getItem('verificationEmail')
    if (verificationEmail) this.$store.commit('SET_SHOW_VERIFICATION', verificationEmail)
    this.googleLogin = this.$helpers.getObjectProperty(window.mySettings, 'google.login', 0) == 1 ? true : false;
    this.linkedinLogin = this.$helpers.getObjectProperty(window.mySettings, 'linkedin.login', 0) == 1 ? true : false;
  },

  methods: {
    switchAuthMethod() {
      this.proceedWithMagicLink = !this.proceedWithMagicLink;
      this.magicLinkRequestSuccess = false;
    },
    requestMagicLink() {
        this.isRequesting = true;
        const payload = {
            email: this.form.email,
            user_type: 'candidate'
        }
        this.CandidateModel.requestMagicLink(payload)
        .then((r) => {
            this.$sfeToast.toast('success', 'Success', r.message);
            this.magicLinkRequestSuccess = true;
        })
        .catch((e) => {
            this.$sfeToast.toast('error', 'Error', e.message)
        })
        .finally(() => {this.isRequesting = false})
    },
    handlePasswordInput(value) {
      this.form.password = value;
    },
    login(){
      // this.trackEvent(`Candidate signin started`);
      this.submitting = true
      this.errors = {}
      const data = { ...this.form, password: this.$encryptForBackend(this.form.password) }
      this.CandidateModel.login(data).then(r => {
        this.$sfeToast.toast('success', 'Success', r.message)
        if (r.data.verified_at){
          this.$localEncrypt.saveData('appUserDetails', { ...r.data, company: this.getCompany})
          this.proceed(r.data)
        }else {
          this.verificationEmail = r.data.email
          this.$store.commit('SET_SHOW_VERIFICATION', r.data.email)
        }
        // this.trackEvent(`Candidate successfully signed in`)
      }).catch(e => {
        this.errors = e?.errors || {}
      }).finally(() => {
        this.submitting = false
      })
    },
    authProvider(provider) {
      localStorage.setItem('authProvider', provider)
      this.$auth.authenticate(provider)
        .then(resp =>{
          this.$emit('start:social-media-auth');
          this.socialLogin(provider,resp);
        })
        .catch((e) => {
          this.$sfeToast.toast('error', 'Error', e.message);
          this.$emit('failed:social-media-auth');
        })
    },
    socialLogin(provider,data){
      const socialProfile = provider == 'linkedin' ? 'linkedin-openid' : provider
      this.CandidateModel.socialLogin(socialProfile, data)
            .then(resp => this.proceed(resp.data))
            .catch(() => this.$emit('failed:social-media-auth'))
    },

    handleVerificationEvent(data){
      sessionStorage.removeItem('verificationEmail')
      this.proceed(data)
    },

    proceed(data){
      this.$store.commit('SET_LOGGED_IN_USER', data)
      this.$emit('login:successful')
    },

    handleRegistrationLinkClick() {
      // this.trackEvent('sign-up-started');
      this.$store.commit('CLEAR_VERIFICATION_EMAIL')
      this.$emit('show:registration-form')
    },
  },

  watch: {
    company: {
      deep: true,
      immediate: true,
      handler(newValue) {
        this.getCompany = newValue
      }
    }
  }
}
</script>

<style scoped lang="scss">
::v-deep .sfe-divider-content {
    width: 140% !important;
}
@media screen and (min-width: 320px) {
  .login-form {
    &__secondary-heading {
      &--xs {
        display: block
      }
      &--md {
        display: none
      }
    }
    &__inner-container {
      background-color: #ffffff;
      padding: 20px 30px;
    }
    &__company-logo {
      width: 80px;
    }
  }
}

@media screen and (min-width: 768px) {
  .login-form {
    &__secondary-heading {
      &--xs {
        display: none;
      }
      &--md {
        display: block;
        margin-bottom: 20px;
      }
    }
    &__inner-container {
       background-color: none;
       padding: 0;
    }
    &__company-logo {
      display: none;
    }
    &__skip-section--xs {
      display: none;
    }
  }
}
</style>
